/**
 * Shared helpers for preserving navigation context when moving between
 * list/tab views and detail pages.
 */

export function getReturnPath(location) {
  if (!location) return '';
  return `${location.pathname}${location.search || ''}${location.hash || ''}`;
}

export function getDetailLinkState(location, tab) {
  const state = { from: getReturnPath(location) };
  if (tab) {
    state.fromTab = tab;
  }
  return state;
}

function hasQueryParam(path, key) {
  const queryIndex = path.indexOf('?');
  if (queryIndex === -1) return false;
  const params = new URLSearchParams(path.slice(queryIndex + 1));
  return params.has(key);
}

export function withTabInPath(path, tab, paramName = 'tab') {
  if (!tab || hasQueryParam(path, paramName)) {
    return path;
  }
  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set(paramName, tab);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}

/**
 * Navigate back to the page the user came from.
 * Falls back to browser history, then a default list path.
 */
export function navigateBack(navigate, location, defaultPath) {
  const from = location?.state?.from;
  const fromTab = location?.state?.fromTab;

  if (from) {
    navigate(withTabInPath(from, fromTab));
    return;
  }

  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1);
    return;
  }

  navigate(defaultPath);
}
